import { IonItemDivider } from "@ionic/react";
import { useSelector } from "react-redux";
import { MessageItem } from "../../../components/Message/MessageItem";
import { selectDocumentHistory } from "../../../store/documentShow/selectors/selectDocumentHIstory";
import { selectDocumentStatus } from "../../../store/documentShow/selectors/selectDocumentStatus";
import { DocumentCommentBox } from "./DocumentCommentBox";

export const DocumentHistory: React.FC = () => {
  const messages = useSelector(selectDocumentHistory);
  const documentStatus = useSelector(selectDocumentStatus);
  return (
    <>
      {documentStatus?.code !== "anulled" && <DocumentCommentBox />}

      <hr />
      <section>
        {Object.entries(messages).map(([key, value]: any) => (
          <article key={key}>
            <IonItemDivider className="ion-margin-bottom">{key}</IonItemDivider>

            {value.map((messageItem: any) => (
              <MessageItem key={messageItem.id} message={messageItem} routerLink={``}></MessageItem>
            ))}
          </article>
        ))}
      </section>
    </>
  );
};
